"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WarningTextPlacesEnd = exports.WarningPlacesEnd = exports.Container = void 0;
var _localization = require("@lt/localization");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var WarningPlacesEnd = exports.WarningPlacesEnd = function WarningPlacesEnd(_ref) {
  var flight = _ref.flight,
    hotel = _ref.hotel,
    className = _ref.className,
    isHotelOnly = _ref.isHotelOnly;
  if (!(flight === 'few') && !(hotel === 'few')) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(Container, {
    className: className
  }, !isHotelOnly ? /*#__PURE__*/_react["default"].createElement(WarningTextPlacesEnd, null, _localization.i18n.t('hotelcard.card.fewFlight')) : /*#__PURE__*/_react["default"].createElement(WarningTextPlacesEnd, null, _localization.i18n.t('hotelcard.card.fewHotel')));
};
var Container = exports.Container = _styledComponents["default"].div.withConfig({
  displayName: "WarningPlacesEnd__Container",
  componentId: "sc-t32bz2-0"
})(["font-size:14px;margin-bottom:10px;"]);
var WarningTextPlacesEnd = exports.WarningTextPlacesEnd = _styledComponents["default"].p.withConfig({
  displayName: "WarningPlacesEnd__WarningTextPlacesEnd",
  componentId: "sc-t32bz2-1"
})(["line-height:16px;color:#d0021b;"]);